import * as queryString from 'query-string';

export const getItemFromQueryParam = (paramName: string) => {
  const location = window.location;
  const params = queryString.parse(location.search);
  return params[paramName];
};